import { Button } from "@ofrz/ui-package";
import { StatusBadge } from "components/status-badge";
import { FilterTab } from "components/tab-filter/tab-filter.props";
import { COLORS } from "libs/colors";
import { DataTypes } from "libs/enums";
import { ViewIcon } from "static/images/svgs/view-icon-svg";
import { StringfyDate } from "utils/date";
import translate from "../../utils/translations";
import { formatNumber } from "utils/numbers";
import { ProductItemModel } from "libs/models/batch-model";
export const DynamicTabKeys = [{ Status: DataTypes.Number }];
export const DynamicSearchKeys = {
  Barcode: DataTypes.String,
} as const;
export const productItemsHeaders = [
  {
    title: translate("Barcode_Text", "Barcode"),
    dataIndex: "barcode",
    key: "barcode",
    isSortable: false,
  },
  {
    title: translate("Value_Text", "Value TODO"),
    dataIndex: "balance",
    key: "balance",
    isSortable: false,
  },
  {
    title: translate("Status_Text", "Status TODO"),
    dataIndex: "status",
    key: "status",
    isSortable: false,
  },
  {
    title: translate("Activation_Date_Text", "Activation Date TODO"),
    dataIndex: "activatedAt",
    key: "activatedAt",
    isSortable: false,
  },
  {
    title: translate("Expiration_Date_Text", "Expiration Date TODO"),
    dataIndex: "expirationDate",
    key: "expirationDate",
    isSortable: false,
  },
  {
    title: "",
    dataIndex: "actions",
    key: "actions",
    isSortable: false,
  },
];
export const getProductItemsList = (
  productItemsData: ProductItemModel[],
  onView: (barcode: string) => void
) => {
  const data = [];
  for (var i = 0; i < productItemsData.length; i++) {
    const request = productItemsData[i];
    const row: Record<string, any> = {
      ...request,
      barcode: (
        <div
          className="text-[16px] flex justify-center font-medium text-[#141211]"
          onClick={() => navigator.clipboard.writeText(request.barcode)}
        >
          {request.barcode}
        </div>
      ),
      balance: formatNumber(request.balance),
      status: (
        <StatusBadge
          status={getStatus(request.status)}
          style={getStatusStyle(request.status)}
        />
      ),
      expirationDate: request.expirationDate ? (
        StringfyDate(request.expirationDate)
      ) : (
        <div className="text-[16px] flex justify-center font-medium text-[#141211]">
          -
        </div>
      ),
      activatedAt: request.activatedAt ? (
        StringfyDate(request.activatedAt)
      ) : (
        <div className="text-[16px] flex justify-center font-medium text-[#141211]">
          -
        </div>
      ),
      actions: (
        <div className="flex space-x-2">
          <Button
            className={`${COLORS.TEXT_FORM} !p-0 m-2`}
            onClick={() => onView(request.barcode)}
          >
            <ViewIcon />
          </Button>
        </div>
      ),
    };
    data.push(row);
  }
  return data;
};

const getStatusStyle = (status: number) => {
  switch (status) {
    case 2:
      return "bg-[#ECFDF3] text-green-700 border-green-400";
    case 1:
      return "bg-gray-100 text-gray-700 border-gray-400";
    case 3:
      return "bg-[#FEE2E2] text-red-700 border-red-400";
    default:
      return "bg-gray-100 text-gray-700 border-gray-400";
  }
};
const getStatus = (status: number) => {
  switch (status) {
    case 1:
      return translate("Inactive_Text", "Inactive");
    case 2:
      return translate("Active_Text", "Active");
    case 3:
      return translate("Locked_Text", "Locked");
    case 4:
      return translate("Blocked_Text", "Blocked");
    case 5:
      return translate("Archived_Text", "Archived");
    default:
      return translate("Inactive_Text", "Inactive");
  }
};

export const productItemFilterTabs: FilterTab[] = [
  {
    id: 1,
    value: translate("Cards_Issued_Text", "Cards Issued TODO"),
  },
  {
    id: 2,
    value: translate("Cards_Activated_Text", "Cards Activated TODO"),
  },
  {
    id: 3,
    value: translate("Card_Archived_Text", "Card Archived TODO"),
  },
];
export const getFilterStatus = (status: number) => {
  switch (status) {
    case 2:
      return "Active";
    case 3:
      return "Archived";
    default:
      return "Inactive";
  }
};

export const getBatchStatusStyle = (status: number) => {
  switch (status) {
    case 2:
      return "bg-[#ECFDF3] text-green-700 border-green-400";
    case 1:
      return "bg-gray-100 text-gray-700 border-gray-400";
    case 3:
      return "bg-[#FEE2E2] text-red-700 border-red-400";
    default:
      return "bg-gray-100 text-gray-700 border-gray-400";
  }
};
export const getBatchStatus = (status: number) => {
  switch (status) {
    case 1:
      return translate("Ready_To_Print_Text", "Ready To Print");
    case 2:
      return translate("Printed_Text", "Printed");
    case 3:
      return translate("Canceled_Text", "Canceled");
    default:
      return translate("Paused_Text", "Paused");
  }
};
